import { render, staticRenderFns } from "./BurnTesting.vue?vue&type=template&id=cc83a2e6&scoped=true"
import script from "./BurnTesting.vue?vue&type=script&lang=js"
export * from "./BurnTesting.vue?vue&type=script&lang=js"
import style0 from "./BurnTesting.vue?vue&type=style&index=0&id=cc83a2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc83a2e6",
  null
  
)

export default component.exports